import crudActions from '../../crud/actions'

const actions = crudActions('FORM_BUILDER_')

export default actions
